import { isUnauthorizedError } from './httpErrors';

export const retryUnless401 =
  (maxRetries = 2) =>
  (failureCount: number, error: unknown): boolean => {
    if (isUnauthorizedError(error)) return false;
    return failureCount < maxRetries;
  };
